import { POS_PLAN_QUERY } from '@/constants/plan-of-study-constants';

export const STAFF_ROUTES = {
  subjectArea: {
    list: 'courses/subject-area',
  },
  /** Flat UI routes: `/courses/plans/*` and `/courses/requirements/*` (plus `/staff/courses/...`). */
  plansOfStudy: {
    list: 'courses/plans',
    create: 'courses/plans/create',
    /**
     * Path segments are encoded so spaces/special characters do not break routing.
     * Callers must pass raw ids from the API; pre-encoded values would double-encode and break matching.
     */
    detail: (id: string) => `courses/plans/${encodeURIComponent(id)}`,
    /** Same raw-id contract as `detail`. */
    edit: (id: string) => `courses/plans/${encodeURIComponent(id)}/edit`,
    createRequirement: (planId: string) =>
      `courses/requirements/create?${POS_PLAN_QUERY}=${encodeURIComponent(planId)}`,
    requirementDetail: (planId: string, requirementId: string) =>
      `courses/requirements/${encodeURIComponent(requirementId)}?${POS_PLAN_QUERY}=${encodeURIComponent(planId)}`,
  },
  configurations: {
    list: 'courses/configurations',
  },
  studentCoursePlans: {
    list: 'courses/student-course-plans',
  },
  courseCatalog: {
    list: 'courses/course-catalog',
    add: 'courses/course-catalog/add',
    view: (id: string) => `courses/course-catalog/view/${encodeURIComponent(id)}`,
    edit: (id: string) => `courses/course-catalog/edit/${encodeURIComponent(id)}`,
  },
  recommendations: {
    list: 'courses/recommendations',
    add: 'courses/recommendations/add',
    edit: (courseId: string) => `courses/recommendations/${encodeURIComponent(courseId)}/edit`,
  },
  clusterAndPathway: {
    list: 'courses/clusters',
    create: 'courses/clusters/create',
    detail: (id: string) => `courses/clusters/${encodeURIComponent(id)}`,
    edit: (id: string) => `courses/clusters/${encodeURIComponent(id)}/edit`,
    createSpecialization: (clusterId: string) =>
      `courses/clusters/${encodeURIComponent(clusterId)}/specializations/create`,
    specializationDetail: (clusterId: string, specializationId: string) =>
      `courses/clusters/${encodeURIComponent(clusterId)}/specializations/${encodeURIComponent(specializationId)}`,
  },
};
